import React from 'react';
import { useSelector } from 'react-redux';

import classNames from 'classnames';

import { Section } from 'features/order-tracker/shared-components';
import { getOrderSummaryProducts } from 'features/order-tracker/store/selectors';

import styles from './styles.module.scss';

const MIN_PRODUCTS_LENGTH_FOR_TWO_COLUMNS = 4;

export const OrderSummarySection: React.FC = () => {
  const products = useSelector(getOrderSummaryProducts) || [];

  return (
    <Section bgColor="whitesmoke">
      <h3>Order Summary</h3>
      <ul
        className={classNames(styles.productList, {
          [styles.fourProductsCase]: products.length === MIN_PRODUCTS_LENGTH_FOR_TWO_COLUMNS,
          [styles.multipleColumns]: products.length > MIN_PRODUCTS_LENGTH_FOR_TWO_COLUMNS,
        })}
      >
        {products.map(({ productName, orderItemReference }) => (
          <li key={orderItemReference}>{productName}</li>
        ))}
      </ul>
    </Section>
  );
};
